module.exports = "https://web-assets.ifttt.com/packs/media/service_icons/spotify-37a83baa.svg";